var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import DocumentComparisonsApi from '~/api/document_comparison';
import ProjectDocumentComparisonsApi from '~/api/project-document-comparison';
import ProjectsWorkSpaceApi from '~/api/projects-workspace';
import { useAppSidebar } from '~/layout/main_layout/app_sidebar/provider';
import { transformMetaData } from '~/utils/updateMetadata';
const ProjectDocumentComparisonContext = createContext({});
const ProjectDocumentComparisonProvider = (props) => {
    const { fetchProjectWorkSpace } = useAppSidebar();
    const [error, setError] = useState(null);
    const { id: documentsComparisonId } = useParams();
    const [documentsComparisonDetail, setDocumentComparisonDetail] = useState(null);
    useEffect(() => {
        const getDocumentsComparisonDetail = (id) => __awaiter(void 0, void 0, void 0, function* () {
            if (!id)
                return;
            setDocumentComparisonDetail(null);
            const comparison = yield DocumentComparisonsApi.getById(id);
            if (!comparison) {
                return;
            }
            const modifiedComparison = Object.assign(Object.assign({}, comparison), { documentComparisonId: comparison.id, documents: comparison.documents.map(c => transformMetaData(c)) });
            setDocumentComparisonDetail(modifiedComparison);
        });
        getDocumentsComparisonDetail(documentsComparisonId);
    }, [documentsComparisonId]);
    const attachComparisonToFolder = useCallback((comparisonId, projectId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield ProjectDocumentComparisonsApi.post({
                projectId,
                documentComparisonId: comparisonId,
            });
            return response;
        }
        catch (error) {
            setError(error);
        }
    }), []);
    const createProject = useCallback((folderName, parentFolderId) => __awaiter(void 0, void 0, void 0, function* () {
        const newProject = yield ProjectsWorkSpaceApi.post({
            project: {
                name: folderName,
                isArchived: false,
            },
            parentProjectId: parentFolderId !== null && parentFolderId !== void 0 ? parentFolderId : '',
        });
        yield fetchProjectWorkSpace();
        return newProject;
    }), [fetchProjectWorkSpace]);
    const deleteComparisonFromFolder = useCallback((id) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield ProjectDocumentComparisonsApi.deleteById(id);
            fetchProjectWorkSpace();
            return response;
        }
        catch (error) {
            setError(error);
        }
    }), [fetchProjectWorkSpace]);
    const value = {
        error,
        documentsComparisonDetail,
        attachComparisonToFolder,
        deleteComparisonFromFolder,
        createProject,
    };
    return React.createElement(ProjectDocumentComparisonContext.Provider, Object.assign({ value: value }, props));
};
const useProjectDocumentComparison = () => {
    const ctx = useContext(ProjectDocumentComparisonContext);
    if (ctx === undefined) {
        throw new Error('ProjectDocumentComparisonContext can only be used under the ProjectDocumentComparisonProvider');
    }
    return ctx;
};
export { useProjectDocumentComparison, ProjectDocumentComparisonProvider, };
